import { Input } from "@mantine/core"
import { MIME_TYPES } from "@mantine/dropzone"
import { IconX } from "@tabler/icons-react"
import { ActionIcon, DEFAULT_MAX_SIZE, DocumentUploader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { VerifyRawOperationsFileResponseDto } from "~/gen/api"
import { formatFileSize } from "~/utils/formatFileSize"

export type OperationsFileZoneProps = {
  onFileChange: (file: File) => void
  loading: boolean
  rawOperationsChecked: boolean
  rawOperationsUploadedFile: VerifyRawOperationsFileResponseDto | undefined
  setRawOperationsUploadedFile: React.Dispatch<
    React.SetStateAction<VerifyRawOperationsFileResponseDto | undefined>
  >
}

export const OperationsFileZone = ({
  onFileChange,
  loading,
  rawOperationsChecked,
  rawOperationsUploadedFile,
  setRawOperationsUploadedFile,
}: OperationsFileZoneProps) => {
  const { t } = useTranslation("common")

  if (!rawOperationsChecked) {
    return null
  }

  if (rawOperationsUploadedFile) {
    return (
      <Input
        id="raw-operations-file-name"
        value={rawOperationsUploadedFile.fileOriginalName}
        readOnly
        rightSection={
          <ActionIcon
            icon={<IconX />}
            onClick={() => setRawOperationsUploadedFile(undefined)}
            style={{ pointerEvents: "all" }}
            size={16}
          />
        }
      />
    )
  }

  return (
    <DocumentUploader
      onDrop={(files) => onFileChange(files[0])}
      maxFiles={1}
      width="100%"
      maxSize={DEFAULT_MAX_SIZE}
      accept={[MIME_TYPES.csv]}
      title={t("documentUpload.title")}
      helpText={t("documentUpload.helptext", {
        maxSize: formatFileSize(),
      })}
      loading={loading}
    />
  )
}
